import 'js/mobile/common/smart-fixed-header.js';
import 'js/plugin/newsletter-form/newsletter-form.jquery.js';

$('.mpl__toggler').one('click', function () {
  import('js/plugin/multi-level-push-menu.jquery.js').then(() => {
    $('.mpl').multilevelPushMenu()
    $('.mpl__toggler').trigger('click');
  })
})

$('.search-switch').one('click', function () {
  import('js/plugin/search-box.jquery.js').then(() => {
    $('.search-switch').searchBox();
    $('.search-switch').trigger('click');
  })
})

if ($('.random-banner')[0]) {
  import('js/plugin/random-banner.jquery.js').then(() => {
    $('.random-banner').randomBanner();
  })
}

$.getScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js', function () {
  import('js/plugin/one-signal.js').then(() => {
    // console.log('Init OneSignal');
    $('#one-signal__sdk-config').onesignal();
  });
});
